<template>
    <div class="societiesCarousel">
        <!-- <div class="societiesCarousel__tools">
            <div @click="carouselBack" class="societiesCarousel__tools__back icon-button small"
                :class="{ 'disabled': societyNum === 0 }">
                <img src="/img/default/chevron_left.svg" alt="">
            </div>
            <div @click="carouselForward" class="societiesCarousel__tools__forward icon-button small"
                :class="{ 'disabled': societyNum === data.length - 1 }">
                <img src="/img/default/chevron_right.svg" alt="">
            </div>
        </div> -->

        <v-carousel v-model="societyNum" :show-arrows="false" :height="'unset'" hide-delimiters>
            <v-carousel-item v-for="slide in data">
                <societySlide :slide="slide" />
            </v-carousel-item>
        </v-carousel>
    </div>
</template>

<style scoped lang="scss" src="./style.scss"></style>

<script src="./script.js"></script>
